module.exports = __webpack_public_path__ + "app-static/img/success.96819c45.png";